import $ from 'jquery';

$( document ).ready(function($) {
    if ($('.js--vimeo-embed').length) {
        var iframe = document.querySelector('iframe');
        var player = new Vimeo.Player(iframe);

        player.on('pause', function() {
            $('.js--vimeo-play').show();
        });
     }

    $('.js--vimeo-play').bind('click', function() {
        var iframe = document.querySelector('iframe');
        var player = new Vimeo.Player(iframe);
        $('.js--vimeo-play').hide();
        player.play();
    });

    $('.video-player').on('mouseout', function(){
      if (!$(this).find('video')[0].paused)
          $(this).find('.video-player__icon').addClass('video-player__icon--fadeout');
    });

    $('.video-player').on('mouseover', function(){
      $(this).find('.video-player__icon').removeClass('video-player__icon--fadeout')
    });

    $('.video-player__icon').click(function(e) {
        let video = $(this).closest('.video-player').find('video')[0];

        if (video.paused) {
            video.play();
            this.src = "http://seachange.hopsie.org/wp-content/themes/seachange/assets/images/svg/pause-icon.svg";
        }
        else {
            video.pause();
            this.src = "http://seachange.hopsie.org/wp-content/themes/seachange/assets/images/svg/play-icon.svg";
        }
    });
});
